import React, { FC } from "react";
import { Box, Grid, InputLabel, Typography } from "@mui/material";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../model/styles";
import { capitalizeWords } from "../../../hooks/helper";

const FormFieldView: FC<FormFieldProps> = (props) => {
  const classes = useStyles();

  const inputRender = (isInGrid: boolean) => {
    return (
      <Typography
        sx={{
          p: "0px",
          height: props?.heightVal ? props?.heightVal : "100%",
          // textTransform: "capitalize",
          color: props.value ? "#212B36" : "#637381",
          fontSize: props.value ? "14px" : "12px",
          fontWeight: 600,
          lineHeight: "normal",
          // 👇 ADD BLUR HERE
          filter: props?.blurFilter ? "blur(4px)" : "none",
          WebkitFilter: props?.blurFilter ? "blur(4px)" : "none",
        }}
      >
        {props?.prefixIcon}{" "}
        {props?.value ? props?.istextUppercase  ? capitalizeWords(props?.value) : (props?.id ==='email' || props?.id === 'staff_email' || props?.id==="swift_no" || props?.id ==="iban") ? props?.value : props?.value  : "N/A"}
      </Typography>
    );
  };
  return (
    <>
      {props?.label ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ?? 3}
            // className={classes.labelBox}
            sx={{
              marginTop: props?.isNonMarginTop ? "0px !important" : "",
              ...props?.InputProps?.sx,
              display:
                props?.md === 12 || props?.isFlexField ? "flex" : "block",
              alignItems: "center",
              // height:'0px'
            }}
          >
            <InputLabel
              sx={{ color: "#637381", fontWeight: 600, fontSize: "18px" }}
              shrink
              htmlFor={props?.id}
            >
              {props?.label} {props?.md === 12 ? ":" : ""}
              {props?.isRequired && (
                <span style={{ color: "red", fontWeight: 500 }}>*</span>
              )}
            </InputLabel>
            {inputRender(true)}
          </Grid>
          {/* <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 7}
            style={{
              padding: "0px",
              // marginTop: props?.marginTopVal || '',
            }}
          >
            {inputRender(true)}
          </Grid> */}
        </>
      ) : (
        inputRender(false)
      )}
    </>
  );
};

export default FormFieldView;
